export default "__VITE_ASSET__6337f0d1__"